// import ActionType from 'actions/ActionType'
// import { omit } from 'lodash'

export default (state = '', action) => {
  const switchObj = {
    'Inbox.OVERRIDE_SMS_INPUT': () => {
      return action.payload
    },
  }

  // If the function returns falsey, a ternary is required because
  // if `|| state` is used, state will remain the same
  return switchObj?.[action?.type] ? switchObj[action?.type]?.() : state
}
